export default __webpack_public_path__ + "assets/773e137c71d59ca8239d8fa6632158ac.svg";